import React, { Suspense, useEffect, useState } from "react";
import LoadingScreen from "../../../components/loader/loading-screen";
import { Container, Row, Col } from "react-bootstrap";
import "../products.css";

import TestimonialCarousel from "../../../components/carousels/testimonial-carousel";
import TestimonialVideoPlayer from "../../../components/videos/testimonial-video";
import ProductPartners from "../../../components/product-partners";
import ContactForm from "../../../components/forms/contact-form";
import InfoSection from "./components/info-section";
import {
  productContentConfig,
  productUrlRouting,
} from "../../../config/product-content-config";
import HeroBanner from "./components/hero";
import { useLocation } from "react-router-dom";
import SentryVideoTestimonial from "../../../components/videos/sentry-video";

const ProductBaseLayout = () => {
  const [page, setPage] = useState(null);
  const location = useLocation();
  useEffect(() => {
    const currentPath = window.location.pathname;
    const findPath = productUrlRouting.find(
      (data) => data.pathname === currentPath
    );
    const newPage = productContentConfig.find(
      (data) => data.pageName === findPath?.pageName
    );

    if (newPage) {
      setPage(newPage);
    }
  }, [location.pathname]);
  if (!page) return null;

  return (
    <Suspense fallback={<LoadingScreen />}>
      <section className="layout-wrapper">
        <HeroBanner
          title={page.title}
          content={page.content}
          backgroundImage={page.backgroundImage}
          projectCount={page.projectCount}
        />
        <InfoSection
          title={page.title}
          image={page.infoSection?.image}
          alt={page.infoSection?.alt}
          paragraphs={page.infoSection?.paragraphs}
        />
        <TestimonialCarousel />
        <Container>
          <Row>
            <Col xs="12" lg="6">
              <TestimonialVideoPlayer />
            </Col>
            <Col xs="12" lg="6">
              <SentryVideoTestimonial />
            </Col>
          </Row>
        </Container>
        <ContactForm />
        <ProductPartners />
      </section>
    </Suspense>
  );
};

export default ProductBaseLayout;
